import { render, staticRenderFns } from "./formZone.vue?vue&type=template&id=3ef8ff30"
import script from "./formZone.vue?vue&type=script&lang=js"
export * from "./formZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports